export default __webpack_public_path__ + "static/terminal_key_highlight-758b24108d1aad4e10816c8e1bd94ee4.png";